import { DistrictUserViewModel } from '../../modules/district/models/district-user-view.model';
import { RoleViewModel } from '../../modules/auth/models/role-view.model';
import { CompanyUserViewModel } from './company-user-view.model';
import { UnitUserViewModel } from '../../modules/asset/unit/models/unit-user-view.model';

export class UserModel {
    id: number;
    username: string;
    password: string;
    email: string;
    firstName: string;
    lastName: string;
    fullname: string;
    phone: string;
    roles: number[] = [];
    roleViewModels: RoleViewModel[] = [];
    accessLevel: string;
    isActive: boolean;
    districtUserIds: number[] = [];
    districtUsers: DistrictUserViewModel[] = [];
    unitUserIds: number[] = [];
    unitUsers: UnitUserViewModel[] = [];
    companyIds: number[] = [];
    companyUserIds: number[] = [];
    companyUsers: CompanyUserViewModel[] = [];
    accessToken: string;
    tenantId: number;
    
    primaryRole: string;
    primaryRoleId: number;
    activeDisp: string;
    companyUser?: CompanyUserViewModel;

    companyCount: number;
    districtCount: number;
    unitCount: number;
    confirmedEula: boolean = false;
}
